import script from "./MTB_Slides.vue?vue&type=script&setup=true&lang=js"
export * from "./MTB_Slides.vue?vue&type=script&setup=true&lang=js"

import "./MTB_Slides.vue?vue&type=style&index=0&id=7b34591c&lang=css"

const __exports__ = script;

export default __exports__